import { RegistrySortFilterBarProps } from './RegistrySortFilterBar.types'
import css from './RegistrySortFilterBar.styles.scss'
import RegistrySortFilterBarSkeleton from './RegistrySortFilterBar.skeleton'

const RegistrySortFilterBar: React.FC<RegistrySortFilterBarProps> = ({
  sortFilterOptions,
  onSortFilterChange,
}: RegistrySortFilterBarProps) => {
  if (!sortFilterOptions || !onSortFilterChange)
    return <RegistrySortFilterBarSkeleton />

  return (
    <div
      className={css.RegistrySortFilterBar}
      data-testid="RegistrySortFilterBar"
    >
      <h1 className={css.RegistrySortFilterBar__title}>Sort & Filter Bar</h1>
    </div>
  )
}

export default RegistrySortFilterBar
